/**
 * Canonical URLs for the legal documents referenced from SMS opt-in disclosures and the
 * app footers. Twilio's compliance review requires these links inside every opt-in
 * disclosure block, so they are consumed from more than one place — keep the single
 * source of truth here rather than repeating the literals per component.
 */
export const TERMS_OF_SERVICE_URL = "https://myrepeat.com/terms.html";
export const PRIVACY_POLICY_URL = "https://myrepeat.com/privacy-policy.html";
